import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import { GET_TASK_TEMPLATE_BLUEPRINTS } from 'queries'
import { plannerClient } from './index'

const TaskBlueprintContext = React.createContext()

function TaskBlueprintProvider({ children }) {
  const { loading, data, refetch } = useQuery(GET_TASK_TEMPLATE_BLUEPRINTS, {
    client: plannerClient,
  })

  const { taskTemplateBlueprints: taskBlueprints = [] } = data || {}

  return (
    <TaskBlueprintContext.Provider value={{ loading, refetch, taskBlueprints }}>
      {children}
    </TaskBlueprintContext.Provider>
  )
}

function useTaskBlueprints() {
  return useContext(TaskBlueprintContext)
}

export { TaskBlueprintProvider, useTaskBlueprints }
